import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem } from "@material-ui/core";
import { SubscriptionSummary } from "../../../models/Subscription";
import { SubscriptionDisplayCard } from "../../SubscriptionDisplayCard";
import { MessageCard } from "../../MessageCard";
import colors from "../../../constants/colors";

interface SubscriptionSelectorProps {
	//The subscriptions available to be selected.
	subscriptions: SubscriptionSummary[];
	//The callback method for setitng the selected subscriptionId.
	setSubscription: (subscriptionId: string) => void;
	//The currently selected subscription Id to be highlighted.
	selectedSubscriptionId: string | undefined;
	//The Id of the product so that we can link to the subscriptions in the subscription display cards.
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	list: {
		maxWidth: 700,
		maxHeight: 700,
		overflowY: "auto",
		paddingLeft: 5,
		paddingRight: 5,
	},
	listItem: {
		boxShadow: theme.shadows[1],
		marginBottom: theme.spacing(2),
	},
}));

/**
 * Displays a test input field and a submit button to add a new user to the db.
 */
export const SubscriptionSelector = (props: SubscriptionSelectorProps) => {
	const classes = useStyles();
	return React.useMemo(() => {
		return (
			<div data-testid={"subscription-selector"}>
				{props.subscriptions && props.subscriptions.length > 0 ? (
					<List className={classes.list}>
						{props.subscriptions.map((subscription) => {
							return (
								<ListItem
									className={classes.listItem}
									style={{
										cursor: "pointer",
										backgroundColor:
											props.selectedSubscriptionId === subscription.subscriptionId ? colors.gray300 : colors.white,
									}}
									key={subscription.subscriptionId}
									onClick={() => props.setSubscription(subscription.subscriptionId)}
									data-testid={"subscription-selector-card"}
								>
									<SubscriptionDisplayCard htmlLink={true} subscription={subscription} productId={props.productId} />
								</ListItem>
							);
						})}
					</List>
				) : (
					<MessageCard message="No active subscriptions found." />
				)}
			</div>
		);
	}, [classes.list, classes.listItem, props]);
};
